import { toast } from 'react-toastify';

// Default toast options. Position is top-center so warnings / errors / success
// messages appear in the user's natural eye line — anchored at the top middle
// of the page — instead of the bottom corner where they're easy to miss.
const defaultOptions = {
  position: "top-center",
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
};

// Success toast with icon
export const showSuccess = (message, options = {}) => {
  toast.success(message, {
    ...defaultOptions,
    ...options,
    className: 'toast-success-custom',
  });
};

// Error toast with icon
export const showError = (message, options = {}) => {
  toast.error(`✕ ${message}`, {
    ...defaultOptions,
    ...options,
    className: 'toast-error-custom',
    autoClose: 5000, // Errors stay longer
  });
};

// Warning toast with icon
export const showWarning = (message, options = {}) => {
  toast.warning(`⚠ ${message}`, {
    ...defaultOptions,
    ...options,
    className: 'toast-warning-custom',
  });
};

// Info toast with icon
export const showInfo = (message, options = {}) => {
  toast.info(`ℹ ${message}`, {
    ...defaultOptions,
    ...options,
    className: 'toast-info-custom',
  });
};

// Loading toast
export const showLoading = (message = 'Loading...') => {
  return toast.loading(message, {
    className: 'toast-loading-custom',
  });
};

// Update loading toast
export const updateToast = (toastId, type, message) => {
  toast.update(toastId, {
    render: message,
    type: type,
    isLoading: false,
    ...defaultOptions,
  });
};

// Dismiss all toasts
export const dismissAll = () => {
  toast.dismiss();
};

